export default __webpack_public_path__ + "cd3979d8f31c3173e6d4abd1d1e4c74c.webp";